<div class="phone-number-field">
  <lx-dropdown-side-panel-field
    (ngModelChange)="updatePhoneCode($event)"
    [title]="title"
    [(ngModel)]="phoneCode"
    data-qa="phoneNumberField_phoneCode"
    class="phone-number-field__phone-code"
    [options]="residenceCountries"
    [filter]="true"
    filterBy="name"
    optionLabel="phoneCode"
    optionValue="phoneCode"
    placeholder="Select"
    autocomplete="tel-country-code"
  >
    <ng-template #itemTemplate let-country>
      <div>{{ country.name }} {{ country.phoneCode }}</div>
    </ng-template>
  </lx-dropdown-side-panel-field>

  <p-inputMask
    (onBlur)="markAsTouched()"
    (ngModelChange)="updatePhoneNumber($event)"
    [ngModel]="phoneNumber"
    mask="99999999999999"
    [autoClear]="false"
    [slotChar]="''"
    [lxPhonePrefixSanitizer]="prefixes"
    class="phone-number-field__number"
    data-qa="phoneNumberField_inputNumber"
    name="phone"
    autocomplete="tel"
  />
</div>
